import React from 'react';
import {
  TextAppearance,
  TextCustom,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import { PageInformationContainer } from './styled';
import { Page } from '../../typings/reviews';
import { AppConstants } from '../../utils/app-constants';

interface PageInformationProps {
  reviewsPage: Page;
}

const PageInformation: React.FC<PageInformationProps> = props => {
  const showingLabel = 'Showing ';
  let { number, size, totalElements, pageElements } = props.reviewsPage;
  //Component constants
  let startElement = (number - 1) * size;
  let limitNumber = startElement + size;
  let lastElement =
    limitNumber > totalElements ? totalElements % limitNumber : limitNumber;
  if (pageElements) {
    if (number !== AppConstants.API_PAGINATION_BASE) {
      let isFloorNumber = pageElements <= size / 2;
      let modNumber = isFloorNumber ? size - pageElements : size % pageElements;
      startElement = startElement - modNumber;
      let limitNumber = startElement + size;
      lastElement =
        limitNumber > totalElements ? totalElements % limitNumber : limitNumber;
    } else {
      startElement = AppConstants.API_PAGINATION_BASE - 1;
      lastElement = pageElements;
    }
  }
  if (!props.reviewsPage) return <></>;
  return (
    <PageInformationContainer className="pagination-elements">
      <TextCustom
        appearance={TextAppearance.copy100}
        style={{ fontSize: TextSize.TextSize16, fontWeight: TextWeight.light }}
      >
        {showingLabel}
        <TextCustom style={{ fontWeight: TextWeight.bold }}>
          {totalElements > 0 ? `${startElement + 1} - ${lastElement}` : 0}
        </TextCustom>{' '}
        of {totalElements} reviews
      </TextCustom>
    </PageInformationContainer>
  );
};

export default PageInformation;
